<template>
	<p class="hotel-info-disclaimer">
		Bitte beachten Sie, dass es sich um allgemeine Hotelinformationen handelt (ohne Gewähr). Angaben zu den Inklusivleistungen/Ausstattung können je nach gebuchtem Veranstalter variieren. Die verbindliche und gültige Hotelbeschreibung des Veranstalters finden Sie nach Preisprüfung des jeweiligen Angebotes unter Angebotsdetails.
	</p>
</template>
<style lang="scss" scoped>
.hotel-info-disclaimer {
	font-size: $font-small-2;
	line-height: 2.3rem;
	font-weight: $font-weight-regular;
	color: $color-placeholder-text;
}
</style>
